import { render, staticRenderFns } from "./DocumentField.vue?vue&type=template&id=4e91b79c&"
import script from "./DocumentField.vue?vue&type=script&lang=ts&"
export * from "./DocumentField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports